import { createAsyncThunk } from '@reduxjs/toolkit'
import { userServices } from '@services'

/** Retrieve user information via api */
export const fetchProfile = createAsyncThunk('user/fetchProfile', async (token, thunk) => {
    try {
        const response = await userServices.fetchProfile(token)

        return response
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})
